<template>
  <div class="">

    <div class="col-12 text-left">
      <m-a :href="{name:'Chats'}">

        <button class="btn btn-success  d-inline-block px-3 rounded-pill" type="button">
          همه چت ها
        </button>

      </m-a>
    </div>
    <div class="col-12">
      <chat-form :submitFunction="startNewChatWrapper"/>
    </div>


  </div>
</template>


<script>
import ChatForm from "@/plugin/components/dashboard/Chat/ChatForm.vue";

export default {
  name: "ChatCreate",
  components: {ChatForm},
  methods: {
    startNewChatWrapper(form) {
      form.withoutState = true
      this.$store.dispatch('Chat/startNewChat', form).then(res => {
        let data = res.data.data.data
        let slug = data.slug

        let routeData = this.$router.resolve({name:'SingleChat',params:{slug:slug}});
        window.open(routeData.href, '_blank');

      })
    }
  }
}
</script>


<style scoped>

</style>